import LocalSeoPage from '@/pages/local/components/LocalSeoPage';
import { aracruzRedutores } from '@/mocks/localSeoData';

export default function RecuperacaoRedutoresIndustriaisAracruz() {
  return <LocalSeoPage data={aracruzRedutores} />;
}